import { useCallback } from "react";
import agent from "../agent";

const useCatalogApi = () => {
    const handleCatalogRequest = useCallback(
        async (method, [getRequest, putRequest]) => {
            let request;

            switch (method) {
                case "GET":
                    request = getRequest;
                    break;
                case "PUT":
                    request = putRequest;
                    break;
                default:
                    console.error("Incorrect method: Use GET or PUT");
                    return;
            }

            if (!request) {
                return;
            }

            const { callback, params } = request;
            await callback(...params);
        },
        []
    );

    const deleteRecord = useCallback(async (type, code, id ) => {
        switch (type) {
            case "monitoring":
                await agent.CatalogType.deleteCatalogType(code, id);
                break;
            case "billing":
                await agent.AccountingDictionary.deleteRecord(code, id);
                break;
            default:
                console.error("Incorrect type: Use monitoring or billing");
                break;
        }
    }, []);

    return { handleCatalogRequest, deleteRecord };
};

export default useCatalogApi;